import { ResponseMessage } from './types';

async function fetchChatResponse(
  url: string,
  sessionId: string,
  data: string,
  chatCount: number,
  uniqueId: string,
  userIp: string | null
): Promise<ResponseMessage> {
  try {
    const body = {
      sessionId: sessionId,
      action: 'sendMessage',
      chatInput: data,
      chatCount: chatCount,
      uniqueId: uniqueId,
      userIp: userIp,
    };

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });

    const text = await response.text();

    if (response.ok) {
      //Trim the spaces leading and trailing
      if (!text.trim())
        return {
          content: `No Data`,
        };

      //parse the recieved JSON to the required format
      try {
        const result = JSON.parse(text);
        const key = Object.keys(result)[0];
        return {
          content: result['output'],
        };
      } catch (err) {
        console.error('Invalid JSON:', text);
      }
    } else {
      // Handle error responses (non-2xx status codes)
      try {
        const errorResult = JSON.parse(text);

        // Check for rate limit error (429 status code)
        if (response.status === 429 && errorResult.message) {
          return {
            content: errorResult.message,
          };
        }

        // Handle other error responses with a message field
        if (errorResult.message) {
          return {
            content: errorResult.message,
          };
        }
      } catch (err) {
        console.error('Error parsing error response:', text);
      }
    }

    return {
      content: "Sorry, Didn't get that. Please try again.",
    };
  } catch (err) {
    return {
      content: "Sorry, Didn't get that. Please try again.",
    };
  }
}

export { fetchChatResponse };
